import { gql } from "@apollo/client";

const SEND_NOTIFICATION = gql`
  mutation sendNotification(
    $id: ID!
    $zones: [String]
    $subZones: [String]
  ) {
    sendNotification(
      id: $id
      zones: $zones
      subZones: $subZones
    ) {
      success
      message
      notification {
        id
      }      
    }
  }
`;

const UPDATE_NOTIFICATION = gql`
  mutation updateNotification(
    $id: ID!
    $notification: NotificationUpdateInput!
  ) {
    updateNotification(id: $id, notification: $notification) {
      success
      message
      notification {
        id
      }   
    }
  }
`;

const GET_SUBZONES = gql`
  query subZones($params: QueryParams) {
    subZones(params: $params) {
      results {
        id
        name
      }
    }
  }
`;

const GET_ZONES = gql`
  query zones($params: QueryParams) {
    zones(params: $params) {
      results {
        id
        name
      }
    }
  }
`;

export { SEND_NOTIFICATION, UPDATE_NOTIFICATION, GET_SUBZONES, GET_ZONES };
